const URLs = {
  local: 'http://localhost:8000',
  development: 'https://development.v2.chameleoncreator.com',
  staging: 'https://staging.v2.chameleoncreator.com',
  production: 'https://v2.chameleoncreator.com',
  anz: 'https://anz.v2.chameleoncreator.com',
};

export type GetParams = {
  hasRemote: boolean;
  projectId: string | number;
  accountId: string;
  versionId: string | number;
  source: string;
  url: string;
  analyticsUrl: string;
  enableAnalytics: boolean;
  mode: string;
  hosted: boolean;
};

function getParams(): GetParams {
  var qu = window.location.href.split('?')[1];
  var data = {} as any;

  if (!qu) {
    var env = window.env || 'local';

    return {
      hasRemote: false,
      projectId: window.projectId || '-1',
      accountId: window.accountId || '-1',
      versionId: window.versionId || '-1',
      source: window.source || 'none',
      url: URLs[env.toLowerCase()] || URLs.local,
      analyticsUrl: window.analyticsUrl || 'http://localhost:8787',
      enableAnalytics: window.enableAnalytics || false,
      hosted: window.hosted == true,
      mode: window.mode || 'DEVELOPMENT',
    };
  } else {
    var params = qu.split('&');

    for (var x in params) {
      data[params[x].split('=')[0]] = params[x].split('=')[1];
    }

    var env = data.env || 'local';

    return {
      hasRemote: true,
      projectId: window.projectId || data.project_id || '0',
      accountId: window.accountId || data.account_id || '0',
      versionId: window.versionId || data.version_id || '0',
      source: window.source || 'none',
      url: URLs[env.toLowerCase()] || URLs.local,
      analyticsUrl: window.analyticsUrl || 'http://localhost:8787',
      enableAnalytics: window.enableAnalytics || false,
      mode: window.mode || data.mode,
      hosted: window.hosted == true || data.hosted == 'true',
    };
  }
}

window.chameleon = {
  CHAMELEON_URL: getParams().url,
};

window.hasMode = mode => {
  const windowMode = getParams().mode || 'DEVELOPMENT';

  return mode === windowMode;
};

window.getParams = getParams;
